import axios from 'axios';

/**
 * @returns string The CSRF param value
 */
export const getCsrfParam = () => document.querySelector('meta[name="csrf-param"]').content;

/**
 * @returns string The CSRF token value
 */
export const getCsrfToken = () => document.querySelector('meta[name="csrf-token"]').content;

/**
 * Submits a form to Yii through axios, taking into account the csrf token as well
 *
 * @param {string} url The URL to submit to
 * @param {Object|Element} [data] A form element or a key-value object that contains the data to send
 * @returns {Promise} An axios promise
 */
export const submitYiiForm = (url, data= {}) => {
    let formData;
    if (data instanceof Element) {
        formData = new FormData(data);
    } else {
        formData = new FormData();
        Object.keys(data).forEach(key => formData.append(key, data[key]));
    }
    formData.append(getCsrfParam(), getCsrfToken());

    return axios.post(url, formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
};

/**
 * Redirects the user to a page using POST instead of GET
 * @param url string
 * @param data object
 */
export const postRedirect = (url, data) => {
    data = data || {};
    const form = document.createElement('form');
    form.action = url;
    form.method = 'POST';

    Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
};
